import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { whatsAppChatUrl } from "../config/site";

/**
 * Floating WhatsApp (audit: Indian buyers expect quick chat).
 * Hidden on checkout verify to reduce distraction during OTP entry.
 */
function WhatsAppFloat() {
  const { pathname } = useLocation();
  if (pathname === "/checkout-verify") return null;

  const href = whatsAppChatUrl("Hi Rencin Gifting, I have a question about your gift boxes.");

  return (
    <a
      href={href}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <FaWhatsapp size={32} aria-hidden />
    </a>
  );
}

export default WhatsAppFloat;
